module.exports = __webpack_public_path__ + "static/img/ico2.a05573c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_transparente/ico2.png
// module id = 152
// module chunks = 0